export const checksums = {
  "content": "v3.5.0--qlSjlOKwA1ICqaSdR5BY-4b9VTILi071Tf1ItGJ4_Ko",
  "policies": "v3.5.0--GhujWshYDgc5pOGl3Ml5w4MkfJ86YVTgwVG0AKjG6qk",
  "commitments": "v3.5.0--MppiF62faA5RBMhvqkR8sX-V-j9iCNRUv6ZR27bAJvE"
}
export const checksumsStructure = {
  "content": "bgIYhpjRuV8zbHJE_CfelwKpJ_Td6YuGJwixiek8lmI",
  "policies": "Do1ksdsZVZy4mr2Of-XhYoxTDbOcO9zQjro-yDNmvTM",
  "commitments": "-PWDX23nqe91OF6dZSL6Bv1Wf4ewjCh63huRdEkvq3s"
}

export const tables = {
  "content": "_content_content",
  "policies": "_content_policies",
  "commitments": "_content_commitments",
  "info": "_content_info"
}

export default {
  "content": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "policies": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "commitments": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}